import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/shared/contexts/AuthContext'
import { INVITE_ONLY } from '@/shared/lib/inviteOnly'
import AppAccessGate from '@/shared/components/AppAccessGate'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-legal-50 dark:bg-legal-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-legal-600 mx-auto mb-4"></div>
          <p className="text-legal-600 dark:text-legal-400">Cargando...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }

  // Gate only the authenticated owner area; public signing routes never use ProtectedRoute.
  if (INVITE_ONLY) return <AppAccessGate>{children}</AppAccessGate>

  return <>{children}</>
}
